/**
 * @module AlgoliaSoftware
 * @description Initializes and manages Algolia product search grid for Software.
 *
 * Uses the base product search grid component factory for consistency across product types.
 * This is specifically for product search grids, not general site search.
 */

import { createProductSearchGrid } from './BaseProductSearchGrid.js';
import { sortControllerSeries } from './controllerSeries.js';
import { createProductConfig } from '@js/algolia/createProductConfig.js';
import { softwareConfig } from '@js/config/algolia.js';

// Software has no numeric specs to surface on the card.
function getSpecs(_result) {
  return [];
}

function hasSpecs(_result) {
  return false;
}

/**
 * Format Algolia result to match product-card component structure
 *
 * @param {Object} result - The raw Algolia search result object
 * @returns {Object} Formatted data matching product-card structure
 */
function formatCardData(result) {
  return {
    heading: result.title || '',
    url: result.absoluteUri || result.url || '#',
    image: result.productImage || null,
    category:
      result.softwareType && result.softwareType.length
        ? result.softwareType[0]
        : null,
    description: result.description || result.tagline || null,
    truncateDescription: false,
    attributes: [],
    legacy: result.legacy || false,
    controllerSeries: sortControllerSeries(result.controllerSeries),
    hideImage: true,
  };
}

// Create and export the Alpine component using the base factory
export default createProductSearchGrid({
  appId: softwareConfig.app_id,
  apiKey: softwareConfig.api_key,
  indexName: softwareConfig.index,
  configureWidget: createProductConfig('[data-search-software]', { hitsPerPage: 60 }),
  formatCardData,
  getSpecs,
  hasSpecs,
  scrollToSelector: '[data-search-software]',
});
